import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
  {
    path: '/sicknotes',
    name: 'SickNotesView',
    component: () => import(/* webpackChunkName: "sicknotes-view" */ '@/modules/sick_notes/components/SickNotesView'),
    meta: {
      moduleId: 'sickNotes',
      decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
    },
    beforeEnter: checkAuthenticated,
  },
  {
    path: '/sicknotes/:id',
    name: 'SickNoteForm',
    component: () => import(/* webpackChunkName: "sicknotes-form" */ '@/modules/sick_notes/components/SickNoteForm'),
    meta: { moduleId: 'sickNotes' },
    props: true,
    beforeEnter(to, from, next) {
      beforeEnterCheck(to, from, next);
      to.params['initialHasCertificate'] = false;
    }
  },
]
